import React from 'react';
import './App.css';
import Header from '../Header/Header';
import Timer from '../Timer/Timer';
import Footer from '../Footer/Footer';
import Ballot from '../Ballot/Ballot';
import Propaganda from '../Propaganda/Propaganda';
import SocialFeed from '../SocialFeed/SocialFeed';

function App() {
  return (
    <div className="App">
      <Header />
      <Timer date="Jun 29, 2019" />
      <Ballot />
      <Propaganda />
      <SocialFeed />
      <Footer />
    </div>
  );
}

export default App;
